import { LinearIssueStatusMap } from "hooks/useLinearIssueStatuses";
import React from "react";

/**
 * Checks if a tag matches the Linear issue identifier pattern (ENG-123)
 */
export function isLinearIssue(tag: string): boolean {
  return /^ENG-\d+$/i.test(tag);
}

/**
 * Handles tag click - opens Linear issue on ctrl/cmd+click, otherwise calls onNormalClick
 */
export function handleLinearTagClick(
  e: React.MouseEvent,
  tag: string,
  linearStatusMap: LinearIssueStatusMap,
  onNormalClick?: () => void
): void {
  const upperTag = tag.toUpperCase();
  if (isLinearIssue(tag) && linearStatusMap[upperTag]) {
    const issueInfo = linearStatusMap[upperTag];
    // Ctrl+Click or Cmd+Click opens Linear issue
    if (e.ctrlKey || e.metaKey) {
      e.stopPropagation();
      window.open(issueInfo.url, "_blank", "noopener");
      return;
    }
  }
  // Normal click behavior
  e.stopPropagation();
  if (onNormalClick) {
    onNormalClick();
  }
}

/**
 * Handles tag double-click - opens Linear issue if it's a Linear tag
 */
export function handleLinearTagDoubleClick(
  e: React.MouseEvent,
  tag: string,
  linearStatusMap: LinearIssueStatusMap
): void {
  const upperTag = tag.toUpperCase();
  if (isLinearIssue(tag) && linearStatusMap[upperTag]) {
    const issueInfo = linearStatusMap[upperTag];
    e.stopPropagation();
    window.open(issueInfo.url, "_blank", "noopener");
  }
}
